"use client";

// مرز code-split سمت client: dynamic() فقط داخل کامپوننت client چانک جدا می‌سازد
// (از Server Component همه‌ی کد client صفحه‌ها در یک چانک مشترک می‌آمد).
import dynamic from "next/dynamic";

// بدون loading fallback: داده از سرور می‌آید و با fallback، HTML اول اسکلتون بود و محتوای واقعی
// در یک div مخفی می‌ماند تا اسکریپت جابه‌جایش کند (با JS خاموش فقط اسکلتون دیده می‌شد).
export default dynamic(() => import("./_component"));
